import { render, staticRenderFns } from "./PrizeResources.vue?vue&type=template&id=cebcc7da&scoped=true&"
import script from "./PrizeResources.vue?vue&type=script&lang=js&"
export * from "./PrizeResources.vue?vue&type=script&lang=js&"
import style0 from "./PrizeResources.vue?vue&type=style&index=0&id=cebcc7da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cebcc7da",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data-jenkins/jenkins/workspace/html-cube-webapi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cebcc7da')) {
      api.createRecord('cebcc7da', component.options)
    } else {
      api.reload('cebcc7da', component.options)
    }
    module.hot.accept("./PrizeResources.vue?vue&type=template&id=cebcc7da&scoped=true&", function () {
      api.rerender('cebcc7da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/OwnWorkbench/PrizeResources/PrizeResources.vue"
export default component.exports